'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const { getCategoryLink } = require('../../support/slug-helper');

function getCategoryList({ keyAuthData, categoryData }) {
  return keyAuthData.categories
    .map(item => categoryData.find(({ Id }) => Id === item.categoryId))
    .filter(item => !!item)
    .sort(({ Name: a }, { Name: b }) => (a === b ? 0 : a < b ? -1 : 1));
}

function CategoryLinks({ keyAuthData, categoryData, routes }) {
  const list = getCategoryList({ keyAuthData, categoryData });

  return h('.category-links', [
    h('.category-links-inner', [
      h(
        'ul.category-links-list',
        {
          'data-bhw': 'BrowseCategories',
        },
        list.map(item =>
          h(
            'li.category-links-item',
            h(WithI18n, {}, i18n =>
              h(
                'a',
                getCategoryLink({
                  categoryName: i18n.t(`js.modules.category.Name.${item.Id}`),
                  routes,
                }),
                i18n.t(`js.modules.category.Name.${item.Id}`)
              )
            )
          )
        )
      ),
    ]),
  ]);
}

module.exports = CategoryLinks;
